<template>
<div>
        <el-form :model="detailForm" label-width="105px" style="height:60vh;overflow-y:scroll;overflow-x:hidden;">
            <el-row :gutter="10">
                <el-col :span="12">
                    <el-form-item label="项目名称">
                        <el-select
                        disabled
                        v-model="detailForm.projectId"
                        placeholder="请选择项目名称"
                        style="width: 100%"
                        @change="(value) => projectChange(value, 1)"
                        >
                            <el-option
                                v-for="item in projectList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="区域名称">
                        <el-select 
                        disabled
                        v-model="detailForm.areaId" placeholder="请选择区域名称" style="width: 100%">
                            <el-option
                                @change="(value) => areaChange(value, 1)"
                                v-for="item in areaList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="10">
                <el-col :span="12">
                    <el-form-item label="场馆类型">
                        <el-select  
                        disabled
                        v-model="detailForm.type" placeholder="请选择场馆类型" style="width: 100%">
                            <el-option
                                v-for="item in typeList"
                                :key="item.dictKey"
                                :label="item.dictValue"
                                :value="item.dictKey"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="场馆名称">
                        <!-- <el-select 
                        disabled
                        v-model="detailForm.venueId" placeholder="请选择活动区域">
                            <el-option
                                v-for="item in venueList"
                                :key="item.id" 
                                :label="item.name" 
                                :value="item.id"
                            >
                            </el-option>
                        </el-select> -->
                        <el-input 
                        disabled
                        v-model="detailForm.name"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="10">
                <el-col :span="8">
                    <el-form-item label="参会人数">
                        <el-input  
                        disabled
                        v-model="detailForm.attendance" placeholder="请选择活动区域">
                            <!-- <el-button 
                                @click="showUserListInfo"
                            slot="append">点击查看人员信息</el-button> -->
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="申请公司">
                        <el-input
                        disabled
                        v-model="detailForm.applyCompany" placeholder="请输入申请公司">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="申请人">
                        <el-input   
                        disabled
                        v-model="detailForm.applyName" placeholder="请输入申请人">
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="8">
                    <el-form-item label="证件号">
                        <el-input 
                        disabled
                        v-model="detailForm.applyCertNo" placeholder="请输入证件号">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="申请人手机">
                        <el-input 
                        disabled
                        v-model="detailForm.applyPhone" placeholder="请输入申请人手机">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="申请时间">
                        <el-input 
                        disabled
                        v-model="detailForm.createTime" placeholder="请输入申请人">
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="8">
                    <el-form-item label="预定起期">
                        <el-input 
                        disabled
                        v-model="detailForm.startTime" placeholder="请输入申请人">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="预定止期">
                        <el-input 
                        disabled
                        v-model="detailForm.endTime" placeholder="请输入申请人手机">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="场馆租金(元)">
                        <el-input 
                        disabled
                        v-model="detailForm.venueAmount" placeholder="请输入申请人">
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                    <el-form-item label="备注说明">
                        <el-input 
                        disabled
                        v-model="detailForm.description" placeholder="请输入申请人">
                        </el-input>
                    </el-form-item>
            </el-row>
            <el-row>
                <el-col :span="8">
                    <el-form-item label="服务项">
                        <el-input 
                        disabled
                        v-model="serviceConfigNames" placeholder="请输入申请人">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="服务费总额(元)">
                        <el-input 
                        disabled
                        v-model="detailForm.serviceAmount" placeholder="请输入申请人手机">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="费用总额(元)">
                        <el-input 
                        disabled
                        v-model="detailForm.totalAmount" placeholder="请输入申请人">
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <!-- <el-row>
                    <el-form-item label="审核说明">
                        <el-input 
                        disabled
                        v-model="detailForm.auditDescription" placeholder="请输入申请人">
                        </el-input>
                    </el-form-item>
            </el-row> -->
            <el-row>
                
                <el-col :span="12">
                    <el-form-item label="" label-width="0px">
                <div>会议室配置</div>
                        <el-table
                        height="250"
                            :data="tempConfigList"
                            border
                            style="width: 100%">
                            <el-table-column
                            fixed
                            label="序号"
                            type="index"
                            width="50">
                            </el-table-column>
                            <!-- <el-table-column
                            prop="projectName"
                            label="项目名称"
                            width="100">
                            </el-table-column> -->
                            <el-table-column
                            prop="chargeTypeName"
                            label="收费方式"
                            width="120">
                            </el-table-column>
                            <el-table-column
                            prop="name"
                            label="服务名称"
                            width="120">
                            </el-table-column>
                            <el-table-column
                            prop="fee"
                            label="服务费"
                            width="120">
                            </el-table-column>
                            <el-table-column
                            prop="description"
                            label="服务说明"
                            width="">
                            </el-table-column>
                        </el-table>
                            <el-pagination
                            @size-change="handleConfigSizeChange"
                            @current-change="handleConfigCurrentChange"
                            :current-page="configPage.currentPage"
                            :page-sizes="[10]"
                            :page-size="configPage.size"
                            layout="total, prev, pager, next"
                            :total="configPage.total">
                            </el-pagination>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="" label-width="10px">
                <div>参会人员</div>
                        <el-table
                                height="250"
                                :data="tempUserList"
                                border
                                style="width: 100%;">
                                </el-table-column>
                                <el-table-column
                                label="序号"
                                type="index"
                                width="50">
                                </el-table-column>
                                <el-table-column
                                prop="name"
                                label="姓名"
                                width="100">
                                </el-table-column>
                                <el-table-column
                                prop="phone"
                                label="电话"
                                width="150">
                                </el-table-column>
                                <el-table-column
                                prop="certNo"
                                label="证件号"
                                width="">
                                </el-table-column>
                                <el-table-column
                                prop="plateNo"
                                label="车牌号"
                                width="">
                                </el-table-column>
                            </el-table>
                            <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="page.currentPage"
                            :page-sizes="[10]"
                            :page-size="page.size"
                            layout="total, prev, pager, next"
                            :total="page.total">
                            </el-pagination>
                    </el-form-item>
                </el-col>
            </el-row>
            
        </el-form>
        <div slot="footer" class="dialog-footer" style="text-align:center;">
            <div style="height:1rem"></div>
            <el-button type="primary" @click="auditPassAction">审批通过</el-button>
            <el-button type="default" @click="showAuditDialog">不予通过</el-button>
            <el-button @click="$emit('detailClose',false)">关 闭</el-button>
        </div>


    <el-dialog title="不予通过" custom-class="add-dialog" v-if="dialogFormVisibleNotPass" :visible.sync="dialogFormVisibleNotPass" append-to-body>
    
            <el-form :model="auditForm" ref="auditForm" :rules="rules" label-width="105px">
                <el-row :gutter="10">
                    <el-form-item label="原因" label-width="50px">
                        <el-input type="textarea" v-model="auditForm.auditDescription" maxlength="200"></el-input>
                    </el-form-item>
                </el-row>
            </el-form>
            
        <div slot="footer" class="dialog-footer" style="text-align:center;">
            <el-button @click="auditNotPassAction" size="small" type="primary">确定</el-button>
            <el-button @click="dialogFormVisibleNotPass = false" size="small">关闭</el-button>
        </div>
        </el-dialog>



    </div>
</template>

<script>
import {getVenueApplyMember,addVenueApplyMember,removeVenueApplyMember,auditChangeStatus,getVenueChargeTypeList} from '@/api/v4ward/stadium-management/audit';


export default {
    props:['dialogFormVisibleDetail','detailForm','projectList','areaList','typeList','venueList'],
    data(){
        return{
            configPage:{
                currentPage:1,
                size:10,
                total:0
            },
            page:{
                currentPage:1,
                size:10,
                total:0
            },
            tempUserList:[],
            tempConfigList:[],
            serviceConfig:[],
            venueChargeTypeList:[],
            serviceConfigNames:' ',
            dialogFormVisibleNotPass:false,
            addUserList:[],
            auditForm:{
                auditDescription:""
            },
            
        rules: {
            auditDescription: [
                { required: true, message: '请输入活动名称', trigger: 'blur' },
            ],
        },
        }
    },
    created(){
        let projectId = this.detailForm.projectId;
        let projectName = this.detailForm.projectName;
        let self = this;
        let ids = [];
        let serviceConfig = [];
        getVenueChargeTypeList().then(({data})=>{
            self.venueChargeTypeList = data;
            console.log();
            self.detailForm.serviceConfig.forEach((ele,index)=>{
                let chargeTypeName = '';
                ele.projectId = projectId;
                ele.projectName = projectName;
                self.venueChargeTypeList.forEach((_ele)=>{
                    console.log(ele.chargeType,_ele.dictKey);
                    if(ele.chargeType==_ele.dictKey){
                        chargeTypeName = _ele.dictValue;
                    }
                });
                console.log(chargeTypeName);
                serviceConfig.push({
                    projectId:projectId,
                    projectName:projectName,
                    chargeTypeName:chargeTypeName,
                    name:ele.name,
                    fee:ele.fee,
                    description:ele.description
                })
                ids.push(ele.name);
            });
            console.log(serviceConfig);
            self.serviceConfig = serviceConfig;
                self.serviceConfigNames = ids.join(',');
            self.addUserList = self.detailForm.applyMembers;
            console.log(self.detailForm.applyMembers,self.addUserList);
            self.serviceConfigNames = self.serviceConfigNames||' ';
            this.handleConfigPageAction();
            this.showUserListInfo();
        })
    },
    methods:{
        showAuditDialog(){
            this.dialogFormVisibleNotPass = true;
        },
        auditNotPassAction(){
            let self = this;
            if(!self.auditForm.auditDescription){
                this.$message.error('请填写原因!');
                return;
            }
            auditChangeStatus({id:self.detailForm.id,applyStatus:5,auditDescription:self.auditForm.auditDescription}).then((res)=>{
                this.$message.success('操作成功!');
                this.dialogFormVisibleNotPass = false
                this.$emit('detailClose',false);
            })
        },
        auditPassAction(){
            let self = this;
            auditChangeStatus({id:self.detailForm.id,applyStatus:2,auditDescription:''}).then((res)=>{
                this.$message.success('操作成功!');
                this.$emit('detailClose',false);
            })
        },
        handleConfigPageAction(){
            let self = this;
            this.configPage.total = this.serviceConfig.length;
            let startIndex = (self.configPage.currentPage-1)*self.configPage.size;
            this.tempConfigList = this.serviceConfig.slice(startIndex,startIndex+self.configPage.size);
        },
        handleConfigCurrentChange(val){
            console.log(this.configPage);
            this.configPage.currentPage = val;
            this.handleConfigPageAction();
        },
        handleConfigSizeChange(val){
            console.log(this.configPage);
            this.configPage.size = val;
            this.handleConfigPageAction();
        },
        handleCurrentChange(val){
            console.log(this.page);
            this.page.currentPage = val;
            this.showUserListInfo();
        },
        handleSizeChange(val){
            console.log(this.page);
            this.page.size = val;
            this.showUserListInfo();
        },
        showUserListInfo(type){
            let self = this;
            // this.addUserList=[];
            this.tempUserList = [];
            // this.userForm={};
            getVenueApplyMember({
                applyId:self.detailForm.id,
                current:self.page.currentPage,
                size:self.page.size
            }).then(({data})=>{
                this.tempUserList = data.records;
                // console.log(this.addUserList);
                // this.handlePageAction_();
                this.page.total = data.total;

            })
            this.dialogFormVisibleUser =true;
            setTimeout(()=>{

                // this.$refs.userForm.clearValidate();
            });
        },
    }
}
</script>

<style lang="scss" scoped>
    ::v-deep .el-date-editor{
        width: 100%!important;
    }
</style>